import { render, staticRenderFns } from "./secondReview.vue?vue&type=template&id=7359e0e2&scoped=true"
import script from "./secondReview.vue?vue&type=script&lang=js"
export * from "./secondReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7359e0e2",
  null
  
)

export default component.exports